import { useState, useEffect, useRef } from 'react';
import '../../../entrydoor.css';
import { formatToDecimal, formatToFractional } from '../../../controls/conversions';

// OverallHeight must be > frameHeight and < 200"
const OverallHeight = ({ value = { value: '', label: '' }, onChange, disabled = false, frameHeight }) => {
  const [selected, setSelected] = useState(value?.value || '');
  const [error,    setError]    = useState('');

  useEffect(() => { setSelected(value?.value || ''); }, [value?.value]);

  const validate = (v) => {
    const num = parseFloat(formatToDecimal(v));
    const fh  = parseFloat(formatToDecimal(frameHeight?.value || '0'));
    if (v && !isNaN(num)) {
      if (num <= fh) {
        setError(`Overall Height must be greater than ${frameHeight?.value || 'Frame Height'}`);
      } else if (num >= 200) {
        setError('Overall Height must be less than 200"');
      } else {
        setError('');
      }
    } else {
      setError('');
    }
  };

  const handleChange = (e) => {
    const v = e.target.value;
    setSelected(v);
    validate(v);
  };

  const handleFocus = (e) => {
    const dec = formatToDecimal(e.target.value);
    setSelected(!dec || dec === '0' ? '' : dec);
  };

  const handleBlur = (e) => {
    const formatted = formatToFractional(e.target.value);
    setSelected(formatted);
    validate(formatted);
    onChange({ value: formatted, label: formatted });
  };

  return (
    <div className="a-container">
      <label htmlFor="SdOverallHeight">Overall Height</label>
      <input
        id="SdOverallHeight"
        value={selected}
        onChange={handleChange}
        onFocus={handleFocus}
        onBlur={handleBlur}
        disabled={disabled}
        placeholder='e.g. 90"'
      />
      {error && <p className="error">{error}</p>}
    </div>
  );
};

export default OverallHeight;
